/* @jsx h */
// @ts-nocheck
import {
  computed,
  defineComponent,
  h,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
} from "vue";
import { FastNumberInput } from "../FastNumberInput";

interface FastQuantitySelectorProps {
  value: number | null;
  onChange: (value: number | null) => void;
  disabled?: boolean;
  disableResponsive?: boolean;
  showInModal?: boolean;
  allowClearingSelectedPreset?: boolean;
}

const PRESET_VALUES = [1, 2, 3, 4, 5, 6, 7, 8];

export const getNextFastQuantityValue = ({
  allowClearingSelectedPreset,
  currentValue,
  preset,
}: {
  allowClearingSelectedPreset?: boolean;
  currentValue: number | null;
  preset: number;
}) => {
  if (currentValue === preset) {
    return allowClearingSelectedPreset ? null : currentValue;
  }

  return preset;
};

export const FastQuantitySelector = defineComponent<FastQuantitySelectorProps>({
  name: "FastQuantitySelector",
  props: {
    value: {
      type: Number as PropType<number | null>,
      default: null,
    },
    onChange: {
      type: Function as PropType<(value: number | null) => void>,
      required: true,
    },
    disabled: Boolean,
    disableResponsive: Boolean,
    showInModal: Boolean,
    allowClearingSelectedPreset: Boolean,
  },
  setup(props) {
    const isCompactViewport = ref(false);

    const visiblePresets = computed(() =>
      !props.disableResponsive && isCompactViewport.value
        ? PRESET_VALUES.slice(0, 3)
        : PRESET_VALUES,
    );

    const customValue = computed(() =>
      props.value != null && !visiblePresets.value.includes(props.value)
        ? props.value
        : null,
    );

    const updateViewport = () => {
      isCompactViewport.value = window.innerWidth < 750;
    };

    onMounted(() => {
      updateViewport();
      window.addEventListener("resize", updateViewport);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", updateViewport);
    });

    const isSelected = (preset: number) => props.value === preset;

    const handlePresetClick = (preset: number) => {
      if (props.disabled) return;

      props.onChange(
        getNextFastQuantityValue({
          allowClearingSelectedPreset: props.allowClearingSelectedPreset,
          currentValue: props.value,
          preset,
        }),
      );
    };

    return () => (
      <div>
        <div
          class={`grid gap-2 ${
            !props.disableResponsive && isCompactViewport.value
              ? "grid-cols-4"
              : "grid-cols-3 sm:grid-cols-5 xl:grid-cols-9"
          }`}
        >
          {visiblePresets.value.map((preset) => {
            const selected = isSelected(preset);
            return (
              <button
                key={preset}
                type="button"
                class={`btn btn-xs lg:btn-md ${
                  selected ? "btn-accent" : ""
                } disabled:cursor-not-allowed disabled:opacity-40`}
                onClick={() => handlePresetClick(preset)}
                disabled={props.disabled}
              >
                {preset}
              </button>
            );
          })}

          <FastNumberInput
            value={customValue.value}
            onChange={props.onChange}
            placeholder="Custom guest count"
            min={1}
            disabled={props.disabled}
            disableResponsive={props.disableResponsive}
            showInModal={props.showInModal}
            isSmall={true}
          />
        </div>
      </div>
    );
  },
});
